import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, ClipboardCheck, MapPin, Building2, UserCheck, Scale } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const REASONS = [
  { icon: BadgeCheck, title: "7+ Years Experience", desc: "More than 7 years of hands-on cleaning experience." },
  { icon: ClipboardCheck, title: "Thousands of Cleaning Jobs Completed", desc: "Experience across many residential and commercial cleaning jobs." },
  { icon: MapPin, title: "Local Gold Coast Service", desc: "Serving Gold Coast homes and businesses." },
  { icon: Building2, title: "Residential & Commercial", desc: "Cleaning solutions for both homes and workplaces." },
  { icon: UserCheck, title: "Personal Service", desc: "Customers can contact the business directly about their cleaning requirements." },
  { icon: Scale, title: "Honest Assessment", desc: "Realistic expectations depending on material, condition and staining." },
];

export const WhyChoose = () => (
  <section data-testid="why-choose-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Overline>Why Choose Kay</Overline>
        <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-brand-ink">
          Why Gold Coast Customers Choose <span className="font-serif italic text-brand">Kay's Carpet Cleaning</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={0.05 * (i % 3)}>
            <div className="group relative border-t border-brand-line/70 py-8 pl-2 pr-4" data-testid={`why-reason-${i + 1}`}>
              <span aria-hidden="true" className="absolute -top-7 right-2 font-display font-bold text-[5.5rem] leading-none text-brand-mist select-none transition-colors duration-500 group-hover:text-brand/20">
                {String(i + 1).padStart(2, "0")}
              </span>
              <r.icon size={22} className="text-brand relative" />
              <h3 className="relative mt-4 font-display text-lg font-medium tracking-tight text-brand-ink">{r.title}</h3>
              <p className="relative mt-2 text-sm text-brand-muted leading-relaxed">{r.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-12">
        <Link
          to="/get-estimate"
          data-testid="why-choose-cta"
          className="group inline-flex items-center gap-2.5 bg-brand hover:bg-brand-dark text-white font-semibold px-7 py-4 rounded-full text-base shadow-[0_10px_30px_rgba(45,90,83,0.28)] transition-[background-color,transform] duration-300 hover:scale-[0.97]"
        >
          Tell Us What You Need Cleaned
          <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);
